/*
 * UniversalLink
 * @module components/UniversalLink
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import {
  flattenToAppURL,
  isInternalURL,
  URLUtils,
} from '@plone/volto/helpers/Url/Url';
import { matchPath } from 'react-router';
import { flattenToAppURLWithClean } from '@package/helpers/Url/Url';

import config from '@plone/volto/registry';

const UniversalLink = ({
  href,
  item = null,
  openLinkInNewTab,
  download = false,
  children,
  className = null,
  title = null,
  ...props
}) => {
  const token = useSelector((state) => state.userSession?.token);
  /* @nk24 begin */
  // siteMainInfoからexcludeHostsを取得 (配列)
  const excludeHosts = useSelector(
    (state) =>
      state?.siteMainInfo?.result?.data?.attributes?.common?.excludeHosts,
  );
  /* @nk24 end */

  let url = href;
  if (!href && item) {
    if (!item['@id']) {
      // eslint-disable-next-line no-console
      console.error(
        'Invalid item passed to UniversalLink',
        item,
        props,
        children,
      );
      url = '#';
    } else {
      //case: generic item
      url = flattenToAppURL(item['@id']);

      //case: item like a Link
      let remoteUrl = item.remoteUrl || item.getRemoteUrl;
      if (!token && remoteUrl) {
        url = remoteUrl;
      }

      //case: item of type 'File'
      if (
        !token &&
        config.settings.downloadableObjects.includes(item['@type'])
      ) {
        url = `${url}/@@download/file`;
      }

      if (
        !token &&
        config.settings.viewableInBrowserObjects.includes(item['@type'])
      ) {
        url = `${url}/@@display-file/file`;
      }
    }
  }

  /* @nk24 begin */
  url = flattenToAppURLWithClean(url, excludeHosts);
  /* @nk24 end */
  const isBlacklisted = (config.settings.externalRoutes ?? []).find(
    (route) =>
      /* @nk24 begin */
      matchPath(url, route.match),
    // matchPath(flattenToAppURL(url), route.match),
    /* @nk24 end */
    /* @nk24 begin */
    // )?.length > 0; // fixed it.
    /* @nk24 end */
  );
  const isExternal = !isInternalURL(url) || isBlacklisted;
  const isDownload = (!isExternal && url.includes('@@download')) || download;
  const isDisplayFile =
    (!isExternal && url.includes('@@display-file')) || false;

  const checkedURL = URLUtils.checkAndNormalizeUrl(url);

  url = checkedURL.url;

  let tag = (
    <Link
      /* @nk24 begin */
      // to={flattenToAppURL(url)}
      to={url}
      /* @nk24 end */
      target={openLinkInNewTab ?? false ? '_blank' : null}
      title={title}
      className={className}
      {...props}
    >
      {children}
    </Link>
  );

  if (isExternal) {
    tag = (
      <a
        href={url}
        title={title}
        target={
          !checkedURL.isMail &&
          !checkedURL.isTelephone &&
          !(openLinkInNewTab === false)
            ? '_blank'
            : null
        }
        rel="noopener noreferrer"
        className={className}
        {...props}
      >
        {children}
      </a>
    );
  } else if (isDownload) {
    tag = (
      <a
        /* @nk24 begin */
        // href={flattenToAppURL(url)}
        href={url}
        /* @nk24 end */
        download
        title={title}
        className={className}
        {...props}
      >
        {children}
      </a>
    );
  } else if (isDisplayFile) {
    tag = (
      <a
        href={flattenToAppURL(url)}
        title={title}
        target="_blank"
        rel="noopener noreferrer"
        className={className}
        {...props}
      >
        {children}
      </a>
    );
  }
  return tag;
};

UniversalLink.propTypes = {
  href: PropTypes.string,
  openLinkInNewTab: PropTypes.bool,
  download: PropTypes.bool,
  className: PropTypes.string,
  title: PropTypes.string,
  item: PropTypes.shape({
    '@id': PropTypes.string.isRequired,
    remoteUrl: PropTypes.string, //of plone @type 'Link'
  }),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

export default UniversalLink;
